export default {
  name: 'MainInfo',
  data () {
    return {
      dataList: [],
      emptyCont: [],
      notice: [],
      weather: [],
      vsl: [],
      tender: [],
      reference: [],
      recruit: [],
      yardTraffic: [],
      contNo: '',
      copinoContNo: '',
      searchBoard: 'Notice',
      searchKeyword: '',
      searchSelect: '00',
      carNo: '',
      sendID: '',
      searchType: 'carNo',
      tabNotice: this.$store.state.imgPath + 'tabNotice.jpg',
      tabTender: this.$store.state.imgPath + 'tabTender.jpg',
      tabData: this.$store.state.imgPath + 'tabData.jpg',
      tabRecruit: this.$store.state.imgPath + 'tabRecruit.jpg',
      tabSearch: this.$store.state.imgPath + 'tabSearch.jpg'
    }
  },
  components: {
  },
  async created () {
    this.dataList = await this.$get('home', '')
    this.emptyCont = this.dataList.emptyCont
    this.notice = this.dataList.notice
    this.weather = this.dataList.weather
    this.vsl = this.dataList.vsl
    this.tender = this.dataList.tender
    this.reference = this.dataList.reference
    this.recruit = this.dataList.recruit
    this.yardTraffic = this.dataList.yardTraffic
  },
  methods: {
    detail (no) {
      this.$router.push({ path: '/Detail/' + no })
    },
    container () {
      if (this.contNo === '' || this.contNo.length !== 11) {
        alert('컨테이너 번호가 올바르지 않습니다.')
      } else {
        this.$router.push({ path: '/Container/' + this.contNo.toUpperCase() })
      }
    },
    board () {
      if (this.searchBoard === '' || this.searchBoard === null) {
        alert('게시판을 선택해 주세요')
      } else if (this.searchSelect === '' || this.searchSelect === null) {
        alert('검색 타입을 선택해 주세요')
      } else if (this.searchKeyword.trim() === '' || this.searchKeyword === null) {
        alert('검색어를 입력해 주세요')
      } else {
        this.$router.push({ path: '/' + this.searchBoard + '/' + this.searchSelect + '/' + this.searchKeyword })
      }
    },
    copinoSend () {
      if (this.carNo.trim() === '' && this.sendID.trim() === '' && this.copinoContNo.trim() === '') {
        alert('검색어를 입력해 주세요')
      } else if (this.carNo.trim() !== '' && this.carNo.trim().length !== 4 && this.carNo.trim().length !== 9) {
        alert('차량번호는 4자리 혹은 9자리를 입력해주세요')
      } else if (this.sendID.trim() !== '' && this.sendID.trim().length !== 8) {
        alert('전송ID는 8자리를 입력해주세요')
      } else if (this.copinoContNo.trim() !== '' && this.copinoContNo.trim().length !== 11) {
        alert('컨테이너 번호는 11자리를 입력해주세요')
      } else if (this.carNo.trim() !== '' && this.sendID.trim() === '' && this.copinoContNo.trim() === '') {
        this.$router.push({ path: '/CopinoSend/' + this.searchType + '/' + this.carNo.trim() })
      } else if (this.carNo.trim() === '' && this.sendID.trim() !== '' && this.copinoContNo.trim() === '') {
        this.$router.push({ path: '/CopinoSend/' + this.searchType + '/' + this.sendID.trim().toUpperCase() })
      } else if (this.carNo.trim() === '' && this.sendID.trim() === '' && this.copinoContNo.trim() !== '') {
        this.$router.push({ path: '/CopinoSend/' + this.searchType + '/' + this.copinoContNo.trim().toUpperCase() })
      }
    }
  },
  watch: {
    searchType: {
      handler: function () {
        this.carNo = ''
        this.contNo = ''
        this.sendID = ''
      }
    }
  }
}
